// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.credentials-page {
  min-height: 70vh;
  background:
    linear-gradient(160deg, rgba(10, 37, 64, 0.05), transparent 45%),
    var(--bg-white, #fff);
}

.credentials-hero {
  padding: 3.5rem 0 1.5rem;
  text-align: center;
}

.credentials-hero h1 {
  margin: 0 0 0.75rem;
  color: var(--primary-dark-blue, #0a2540);
}

.credentials-hero p {
  max-width: 720px;
  margin: 0 auto;
  line-height: 1.8;
  color: var(--text-dark-gray, #333);
}

.credentials-body {
  padding: 1rem 0 4rem;
}

.credentials-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 2rem;
  align-items: start;
}

.credentials-legal-name {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin: 0 0 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(10, 37, 64, 0.12);
}

.credentials-legal-name span {
  font-size: 0.9rem;
  color: #666;
}

.credentials-legal-name strong {
  font-size: 1.15rem;
  color: var(--primary-dark-blue, #0a2540);
  line-height: 1.5;
}

.credentials-list {
  margin: 0;
}

.credentials-row {
  display: grid;
  grid-template-columns: minmax(8rem, 38%) 1fr;
  gap: 0.75rem 1rem;
  padding: 0.7rem 0;
  border-bottom: 1px dashed rgba(10, 37, 64, 0.12);
}

.credentials-row dt {
  margin: 0;
  font-weight: 600;
  color: var(--primary-dark-blue, #0a2540);
}

.credentials-row dd {
  margin: 0;
  line-height: 1.6;
}

.credentials-certificate {
  margin: 0;
  text-align: center;
}

.credentials-certificate a {
  display: block;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(10, 37, 64, 0.12);
  box-shadow: 0 8px 24px rgba(10, 37, 64, 0.14);
}

.credentials-certificate img {
  width: 100%;
  height: auto;
  display: block;
  background: #f7f7f5;
}

.credentials-certificate figcaption {
  margin-top: 0.75rem;
  font-size: 0.9rem;
  color: #666;
}

@media (max-width: 800px) {
  .credentials-grid {
    grid-template-columns: 1fr;
  }

  .credentials-row {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/CredentialsPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB;;yBAEuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF","sourcesContent":[".credentials-page {\n  min-height: 70vh;\n  background:\n    linear-gradient(160deg, rgba(10, 37, 64, 0.05), transparent 45%),\n    var(--bg-white, #fff);\n}\n\n.credentials-hero {\n  padding: 3.5rem 0 1.5rem;\n  text-align: center;\n}\n\n.credentials-hero h1 {\n  margin: 0 0 0.75rem;\n  color: var(--primary-dark-blue, #0a2540);\n}\n\n.credentials-hero p {\n  max-width: 720px;\n  margin: 0 auto;\n  line-height: 1.8;\n  color: var(--text-dark-gray, #333);\n}\n\n.credentials-body {\n  padding: 1rem 0 4rem;\n}\n\n.credentials-grid {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 2rem;\n  align-items: start;\n}\n\n.credentials-legal-name {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin: 0 0 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba(10, 37, 64, 0.12);\n}\n\n.credentials-legal-name span {\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.credentials-legal-name strong {\n  font-size: 1.15rem;\n  color: var(--primary-dark-blue, #0a2540);\n  line-height: 1.5;\n}\n\n.credentials-list {\n  margin: 0;\n}\n\n.credentials-row {\n  display: grid;\n  grid-template-columns: minmax(8rem, 38%) 1fr;\n  gap: 0.75rem 1rem;\n  padding: 0.7rem 0;\n  border-bottom: 1px dashed rgba(10, 37, 64, 0.12);\n}\n\n.credentials-row dt {\n  margin: 0;\n  font-weight: 600;\n  color: var(--primary-dark-blue, #0a2540);\n}\n\n.credentials-row dd {\n  margin: 0;\n  line-height: 1.6;\n}\n\n.credentials-certificate {\n  margin: 0;\n  text-align: center;\n}\n\n.credentials-certificate a {\n  display: block;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid rgba(10, 37, 64, 0.12);\n  box-shadow: 0 8px 24px rgba(10, 37, 64, 0.14);\n}\n\n.credentials-certificate img {\n  width: 100%;\n  height: auto;\n  display: block;\n  background: #f7f7f5;\n}\n\n.credentials-certificate figcaption {\n  margin-top: 0.75rem;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n@media (max-width: 800px) {\n  .credentials-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .credentials-row {\n    grid-template-columns: 1fr;\n    gap: 0.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
